import React, { useState, useEffect } from "react";
import Select, { ActionMeta, SingleValue } from "react-select";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";

import index from "@beeldit/core/services";
import { Debt } from "../models/Debt";

interface Option {
  label: string;
  value: number | string;
}

function CustomSelectWidget(props: any) {
  const {
    id,
    value,
    required,
    disabled,
    readonly,
    onChange,
    formContext,
    filters,
  } = props;
  const [selectedOption, setSelectedOption] = useState<Option | null>(null);
  const [options, setOptions] = useState<Option[]>([]);
  const [elementsData, setElementsData] = useState({ elements: [] });

  const { element, setElement } = formContext;

  const errorHandler = useErrorHandler();

  let queryParams = {
    ...{ relations: "customerTreatment,customerTreatment.treatment" },
    ...filters,
  };

  let queryParamsString = new URLSearchParams(queryParams).toString();

  useEffect(() => {
    index("debts", queryParamsString)
      .then((response: any) => {
        setElementsData(response.data);
      })
      .catch((error: any) => {
        errorHandler(error, null);
      });
  }, []);
  useEffect(() => {
    const options = elementsData.elements.map((debt: Debt) => {
      const treatmentName =
        debt.customer_treatment?.treatment?.name || "Unknown Treatment";
      const comment = debt.comments || "Sin comentario";
      const dateLabel = debt.date
        ? new Date(debt.date).toLocaleDateString()
        : "";
      const remaining = (debt.toPay ?? 0).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      const label = `${comment} | ${treatmentName} | ${dateLabel} | ${remaining}`;
      return { label, value: debt.id };
    });
    setOptions(options);
    const currentSelectedOption = options.find(
      (option) => option.value === value
    );
    setSelectedOption(currentSelectedOption || null);
  }, [elementsData, value]);

  const handleOnChange = (
    newValue: SingleValue<Option>,
    actionMeta: ActionMeta<Option>
  ) => {
    const selectedOption = newValue as Option | null;
    setSelectedOption(selectedOption);
    const model = selectedOption?.value ?? null;
    onChange(model);
  };

  const selectStyles = {
    control: (provided: any) => ({
      ...provided,
      borderColor: "#E7F5F2",
      backgroundColor: "#E7F5F2",
      borderRadius: "0.25rem",
    }),
  };

  const disabledByreadOnly = () => {
    if (typeof readonly === "function") {
      return readonly(element);
    }
    return readonly;
  };

  return (
    <>
      <Select
        id={id}
        options={options}
        value={selectedOption}
        required={required}
        isDisabled={disabled || disabledByreadOnly()}
        onChange={handleOnChange}
        styles={selectStyles}
        placeholder="Selecciona una deuda"
        isClearable={true}
      />
    </>
  );
}

function DebtSelector(props: any) {
  const {
    id,
    options,
    value,
    required,
    disabled,
    readonly,
    onChange,
    formContext,
  } = props;
  return (
    <CustomSelectWidget
      id={id}
      options={options.enumOptions}
      filters={options.filters}
      value={value}
      required={required}
      disabled={disabled}
      readonly={readonly}
      onChange={onChange}
      formContext={formContext}
    />
  );
}

export default DebtSelector;
